/**
 * @generated SignedSource<<aa34bbba7dfd1711b8027ebd5de30583>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutTabs_item$data = {
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
  } | null> | null;
  readonly storyTellingModule: {
    readonly tabs: ReadonlyArray<{
      readonly tabType: string;
      readonly tabTitle: string;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespStorytellingTab_storyTellingTab">;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_item">;
  readonly " $fragmentType": "PdpRespAboutTabs_item";
};
export type PdpRespAboutTabs_item$key = {
  readonly " $data"?: PdpRespAboutTabs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutTabs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutTabs_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabTitle",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespStorytellingTab_storyTellingTab"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutItemPanel_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "aa39f9385b8432b3b4973ced5342b1fe";

export default node;
